import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import BackgroundImage from '../assets/background.jpg';

const MissingPage = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                overflow: 'hidden',
                backgroundImage: `url(${BackgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                color: 'lightgray',
                m: 0,
                p: 2,
            }}
        >
            <Typography variant="h2" sx={{ mb: 2 }}>
                404
            </Typography>
            <Typography variant="h5" sx={{ mb: 4 }}>
                Page Not Found
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={() => navigate('/')}
            >
                Go Home
            </Button>
        </Box>
    );
};

export default MissingPage;
